import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RelativeRedirect from '../../elements/RelativeRedirect';
import EventLeadsDefaultTab from '../../screens/Leads/EventLeadsDefaultTab';
import EventLeadsScanScreen from '../../screens/Leads/EventLeadsScanScreen';
import EventLeadsScreen from '../../screens/Leads/EventLeadsScreen';
import { useStoreLastUsedTab } from '../../screens/Leads/tabs';
import { innerParticipantRoutes } from '../participantsRoutes';

export function leadsTabContent(props) {
    const { eventId, tab } = props.match.params;

    useStoreLastUsedTab(eventId, tab);

    return (
        <Switch>
            <Route path={`${props.match.path}/:sponsorId/participant`} component={innerParticipantRoutes} />
            <Route path={`${props.match.path}/scan`} component={EventLeadsScanScreen} />
            <Route path={`${props.match.path}`} exact component={EventLeadsScreen} />
            <Redirect from={`${props.match.path}/:sponsorId`} to={`${props.match.path}`} />
            <RelativeRedirect to="../.." />
        </Switch>
    );
}

export function leadsRoutes(props) {
    return (
        <Switch>
            <Route path={`${props.match.path}/:tab`} component={leadsTabContent} />
            <Route path={`${props.match.path}`} exact component={EventLeadsDefaultTab} />
            <RelativeRedirect to=".." />
        </Switch>
    );
}
